<app-barra-crud [state]="state" (salvando)="salvar()" (voltando)="busca()" (inserindo)="novo()" (editando)="editar()"
  (excluindo)="excluir()" (cancelando)="cancelar()" [formValido]="f.valid">
</app-barra-crud>
<div class="conteudo cadastro">
  <form role="form" #f="ngForm" novalidate>
    <nav class="topo-abas">
      <div class="nav nav-tabs" id="nav-tab" role="tablist">
        <a translate id="dados-principais-tab" href="#dados-principais" aria-controls="dados-principais"
          aria-selected="true" class="nav-item nav-link active" data-toggle="tab" role="tab">
          {{'parametros.objetivoVenda.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </a>
      </div>
    </nav>
    <div class="tab-content" id="nav-tabContent">
      <div id="dados-principais" aria-labelledby="dados-principais-tab" class="tab-pane fade show active"
        role="tabpanel">
        <header translate class="titulo">{{'parametros.objetivoVenda.cadastro.dadosPrincipais.abaDadosPrincipais'}}
        </header>
        <div class="container-fluid">
          <div class="row">
            <div class="col col-lg-12">
              <small translate class="text-info">{{'parametros.objetivoVenda.cadastro.CampoObrigatorio'}}</small>
              <hr />
            </div>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-2"
              label="{{'parametros.objetivoVenda.cadastro.dadosPrincipais.idObjetivoVenda' |translate}}"
              name="idObjetivoVenda" [(ngModel)]="model.id"
              placeholder="{{'parametros.objetivoVenda.cadastro.dadosPrincipais.idObjetivoVendaPlaceHolder' |translate}}"
              [ativo]="false">
            </app-text-box>
          </div>
          <div class="row">
            <app-dropdown-list-api [state]="state" class="col-md-4 col-lg-5"
              label="{{'parametros.objetivoVenda.cadastro.dadosPrincipais.dealer' |translate}}" name="dealer"
              [(ngModel)]="model.id_dealer" obrigatorio="true" required filtro="dealer">
            </app-dropdown-list-api>
          </div>
          <!-- <div class="row">
            <app-dropdown-list-api [state]="state" class="col-md-4 col-lg-5"
              label="{{'parametros.objetivoVenda.cadastro.dadosPrincipais.produto' |translate}}" name="produto"
              [(ngModel)]="model.codProduto" obrigatorio="true" required filtro="produto">
            </app-dropdown-list-api>
            <ng-container *ngIf="model.codProduto">
              <app-dropdown-list-api [state]="state" class="col-md-4 col-lg-5"
                label="{{'parametros.objetivoVenda.cadastro.dadosPrincipais.modelo' |translate}}" name="modelo"
                [(ngModel)]="model.codModelo" obrigatorio="true" required filtro="modelo">
              </app-dropdown-list-api>
            </ng-container>
          </div> -->
          <div class="row">
            <app-text-box [state]="state" class="col-lg-5"
              label="{{'parametros.objetivoVenda.cadastro.dadosPrincipais.ano' |translate}}" name="ano"
              [(ngModel)]="model.ano" obrigatorio="true" required
              placeholder="{{'parametros.objetivoVenda.cadastro.dadosPrincipais.anoPlaceHolder' |translate}}">
            </app-text-box>
            <app-dropdown-list [state]="state" class="col-md-4 col-lg-5"
              label="{{'parametros.objetivoVenda.cadastro.dadosPrincipais.mes' |translate}}" name="tipoDealer"
              [(ngModel)]="model.mes" required [itens]="meses">
            </app-dropdown-list>
          </div>
          <div class="row">
            <app-text-box [state]="state" class="col-lg-10"
              label="{{'parametros.objetivoVenda.cadastro.dadosPrincipais.quantidade' |translate}}"
              name="valor_previsao" [(ngModel)]="model.valor" obrigatorio="true" required
              placeholder="{{'parametros.objetivoVenda.cadastro.dadosPrincipais.quantidadePlaceHolder' |translate}}">
            </app-text-box>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>